module.exports = __webpack_public_path__ + "img/p30.e3e1ef0f.jpg";